// extracted by mini-css-extract-plugin
export default {"hidden":"Is3EK_NGYlBQlCEbxivP"};